import React from 'react';

/**
 * Shared shell for the app's inline icons: 16px, filled with the surrounding text
 * color, hidden from assistive tech (the hosting control carries the label).
 */
const Icon: React.FC<{ path: string }> = ({ path }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d={path} />
  </svg>
);

export const UndoIcon: React.FC = () => (
  <Icon path="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
);

export const RedoIcon: React.FC = () => (
  <Icon path="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" />
);

export const ApplyIcon: React.FC = () => (
  <Icon path="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
);

export const PlusIcon: React.FC = () => (
  <Icon path="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" />
);
